import { type IconType } from '@/defs/icon'
import { type LabelType } from '@/defs/misc'

export const BRANDS = [
  'archidekt',
  'cardhoarder',
  'cardkingdom',
  'cardmarket',
  'cardsphere',
  'cardtrader',
  'commanderspellbook',
  'crypticcabin',
  'face2face',
  'manapool',
  'moxfield',
  'mtgstocks',
  'scg',
  'spellify',
  'tcgplayer',
] as const
export type BrandType = (typeof BRANDS)[number]
export const isBrandType = (slug?: string): slug is BrandType => BRANDS.includes(slug as BrandType)

type BrandLabelType = LabelType<BrandType, { icon: IconType; labelLong?: string }>
export const BRAND_LABELS: BrandLabelType = {
  archidekt: { icon: 'cards', label: 'Archidekt' },
  cardhoarder: { icon: 'cards', label: 'Cardhoarder', labelLong: 'Cardhoarder (MTGO)' },
  cardkingdom: { icon: 'brand-cardkingdom', label: 'Card Kingdom' },
  cardmarket: { icon: 'brand-cardmarket', label: 'Cardmarket', labelLong: 'Cardmarket (EU)' },
  cardsphere: { icon: 'brand-cardsphere', label: 'Cardsphere' },
  cardtrader: { icon: 'brand-cardtrader', label: 'CardTrader', labelLong: 'CardTrader (EU)' },
  commanderspellbook: { icon: 'cards', label: 'Commander Spellbook' },
  crypticcabin: { icon: 'brand-crypticcabin', label: 'Cryptic Cabin' },
  face2face: { icon: 'brand-face2face', label: 'Face to Face', labelLong: 'Face2Face (CA)' },
  manapool: { icon: 'brand-manapool', label: 'Mana Pool' },
  moxfield: { icon: 'cards', label: 'Moxfield' },
  mtgstocks: { icon: 'cards', label: 'MTGStocks' },
  scg: { icon: 'brand-starcitygames', label: 'Star City Games' },
  spellify: { icon: 'brand-spellify', label: 'Spellify' },
  tcgplayer: { icon: 'brand-tcgplayer', label: 'TCGPlayer' },
}
